const routes = {
    "notice_create_route" : "/notice/create",
    "notice" : "/notice"
}


export default routes;